// extracted by mini-css-extract-plugin
module.exports = {"container":"inputs_container__1v8JY","box":"inputs_box__3RLz3","error":"inputs_error__19AVL"};